'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _trackEvent = require('../utils/trackEvent');

var _constants = require('../utils/constants');

var _createTracker = require('../utils/createTracker');

var _createTracker2 = _interopRequireDefault(_createTracker);

var _isInitialised = require('../utils/isInitialised');

var _isInitialised2 = _interopRequireDefault(_isInitialised);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionView = function () {
  function SessionView(config, context) {
    _classCallCheck(this, SessionView);

    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this.__type = 'SessionView';

    this.context = null;

    var appVersion = config.appVersion,
        globalSnowplowName = config.globalSnowplowName,
        trackerName = config.trackerName,
        trackerSettings = config.trackerSettings;


    this.globalSnowplowName = globalSnowplowName;
    this.appVersion = appVersion;
    this.origin = null;

    // Create the tracker if calling the class to use standalone
    if (!(0, _isInitialised2.default)(globalSnowplowName)) {
      (0, _createTracker2.default)(globalSnowplowName, context.user_id, trackerName, trackerSettings);
    }

    this.setEventContext(context);
  }

  _createClass(SessionView, [{
    key: 'destructor',
    value: function destructor() {
      this.instance = null;
    }
  }, {
    key: 'track',
    value: function track() {
      var origin = '' + window.location.href + window.location.hash;
      var referrer = document.referrer;

      var event = {
        schema: _constants.SESSION_VIEW_EVENT_SCHEMA,
        data: {
          app_version: this.appVersion,
          origin: origin,
          referrer: referrer
        }
      };

      if (origin !== this.origin) {
        this.origin = origin;
        (0, _trackEvent.trackCustomEvent)(this.globalSnowplowName, event, this.context);
      }
    }
  }, {
    key: 'appendEventContext',
    value: function appendEventContext(context) {
      this.context.push(context);
    }
  }, {
    key: 'setEventContext',
    value: function setEventContext(context) {
      this.context = context;
    }
  }]);

  return SessionView;
}();

exports.default = SessionView;
module.exports = exports['default'];